import { menuMobx, productMobx, restaurantConfig } from 'restaurant'
import decorationMobx from 'mobx/app/decoration.mobx'
import { isEmpty, debounce } from '@dt/fe-utils/dist/lodash'
import { handleEleScrollTo } from '@utils'
import scrollController from './scrollController'
import ProductAPI from 'api/product.api'
import { recommendMobx } from '@mobxStore'

let lazyLine = ''
let scst: any

let RecommendProductTimer = null // 商品推送1min定时器
let scrollTop = 0 // 用户无操作定时器
let canRecommendProduct = true // 可以推送商品，间隔一分钟
let runWait = 3000 // 3s后触发时间
let recommendWait = 60000 // 推送之后冷却一分钟
const clientHeight = window.screen.height
const tabHeight = 56

class WaterfallCalc {
  // no -> top
  imgTopMap = {}
  // top -> no
  topImgMap = {}
  lazyCalc = false
  waterfallData = { styleMap: {}, height: 0, offsetTop: 0 }

  // 外边距8px 1.6%；参数multiple倍数
  getWidthPer (multiple = 1) {
    return window.innerWidth * 0.016 * multiple
  }

  getWrapWidth (sourceName) {
    const waterfallWrap = document.querySelector(`.${sourceName}`) as HTMLElement
    return waterfallWrap ? waterfallWrap.offsetWidth : 0
  }

  getWaterfallData () {
    return { ...this.waterfallData }
  }

  clearWaterfallData () {
    this.waterfallData = { styleMap: {}, height: 0, offsetTop: 0 }
  }

  /** 原始数据内加上图片宽高 */
  setProductImgHeight (products?: IViewProduct[]) {
    const itemWidth = window.innerWidth / 2 - this.getWidthPer(3)
    return products.map((item) => {
      if (item.pic) {
        // 计算图片宽高
        let radio = item.picWidth / itemWidth
        let pw = itemWidth
        let ph = item.picHeight / radio
        return {
          ...item,
          pw,
          ph
        }
      }
      return item
    })
  }

  /** 瀑布流计算，支持计算中同时计算图片延迟加载 */
  waterfall (products?: IViewProduct[], lazy = true, key: string = 'no', sourceName?: string, waterfallType: string = '') {
    const waterfallWrap = document.querySelector(`.${sourceName ? sourceName + '-' : ''}waterfall-template`) as HTMLElement
    if (!waterfallWrap || !waterfallWrap.offsetWidth) {
      return
    }
    let overOff = 0
    let indexPostionMap: any = {}
    const itemWidth = waterfallWrap.offsetWidth / 2 - this.getWidthPer(3)
    document.body.style.setProperty(`--${waterfallType}wateritemwidth`, itemWidth + 'px')
    // 当前容器距离顶部的距离
    const offsetTop = (document.querySelector('.product-template') as HTMLElement)?.offsetTop || 0
    let left = this.getWidthPer(2)
    let top = 0 + overOff
    let lt = 0 + overOff
    let rt = 0 + overOff
    // 容器高度
    let maxH = 100 // 阀值100
    if (lazy) {
      this.topImgMap = {}
    }
    const needReCalc = products.find((product, index) => {
      const id = product[key]
      const categoryNo = product.categoryNo || ''
      // 使用后计算方案
      const $productHeight = document.getElementById(`${sourceName || 'waterfall'}product` + id + categoryNo)
      // 找不到 忽略相关
      if (!$productHeight && (['bought', 'coupon'].includes(id) || id.includes('soldout_bar') || id.includes('advert_'))) return false
      if (!$productHeight) {
        console.log('🚌 瀑布流计算失败，需要重算')
        return true
      }
      const thisHeight: number = $productHeight.offsetHeight
      // 优惠券，买过，如果没有高度，就跳过计算
      if (['bought', 'coupon'].includes(id) && thisHeight === 0) {
        return false
      }
      // TODO 更精准的异常处理
      if (thisHeight === 0) {
        return true
      }
      if (lt <= rt) {
        left = this.getWidthPer(2)
        top = lt
        lt += thisHeight + 16
      } else {
        left = this.getWidthPer(4) + itemWidth
        top = rt
        rt += thisHeight + 16
      }
      indexPostionMap[id + categoryNo] = {
        left,
        top,
        width: itemWidth,
        height: thisHeight,
        imgWidth: itemWidth,
      }
      if (lazy) {
        // 延迟滚动加载的方案
        if (product.hasPic) {
          this.imgTopMap[id + categoryNo] = top + offsetTop
          if (this.topImgMap[top + offsetTop]) {
            this.topImgMap[top + offsetTop + 1] = id + categoryNo
          } else {
            this.topImgMap[top + offsetTop] = id + categoryNo
          }
        }
      }
      if (maxH < top + thisHeight) {
        maxH = top + thisHeight
      }
    })
    console.log('🍰没有找到，触发重算 ======> ', needReCalc)
    if (needReCalc) {
      return
    }
    // console.log('🚌 瀑布流餐品位置Map', indexPostionMap)
    // console.log('🚌 Img -> Top Map', this.imgTopMap)
    // console.log('🚌 Top -> Img Map', this.topImgMap)
    // menuMobx.setStyle(indexPostionMap)
    // menuMobx.setWaterfallHeight(maxH + 10)
    // 处理完 确保计算一次滚动 主要处理未滚动就显示的case
    if (lazy) {
      this.scroll(0)
    }
    return (this.waterfallData = { styleMap: indexPostionMap, height: maxH + 10, offsetTop })
  }
  /** 图片延迟加载 */
  lazy (products: IViewProduct[]) {
    const calcLine = products.map(p => p.no).join('')
    if (lazyLine === calcLine) {
      return
    }
    this.lazyCalc = false
    this.topImgMap = {}
    products.findIndex((product, index) => {
      const categoryNo = product.categoryNo || ''
      const isDisable = product.disable
      // 使用后计算方案
      const $productHeight = document.getElementById(restaurantConfig.displayMode + 'product' + product.no + categoryNo)
      // 找不到
      if (!$productHeight) {
        // 售罄餐品可以过滤，不参与计算
        console.log('🚌 列表计算失败，需要重算 =>>', product.no, 'isDisable', isDisable)
        if (!isDisable) {
          this.lazyCalc = true
        }
        return
      }
      const thisOffsetTop: number = $productHeight?.offsetTop || 0
      if (product.hasPic) {
        this.imgTopMap[product.no + categoryNo] = thisOffsetTop
        if (this.topImgMap[thisOffsetTop]) {
          this.topImgMap[thisOffsetTop + 1] = product.no + categoryNo
        } else {
          this.topImgMap[thisOffsetTop] = product.no + categoryNo
        }
      }
    })
    if (!this.lazyCalc) {
      lazyLine = calcLine
      this.scroll(0)
    }
  }
  scroll (scrollTop: number, type?: string) {
    // 图片延迟加载
    if (!isEmpty(this.topImgMap)) {
      // 当前容器距离顶部的距离
      for (const key in this.topImgMap) {
        const top = parseFloat(key)
        const productNo = this.topImgMap[key]
        //  + window.innerHeight + 120
        // 添加屏幕往下200px的偏移量
        if (top < (scrollTop + window.innerHeight + 200)) {
          // console.log('🚌 延迟Image Push', productNo)
          if (type === 'recommend') {
            recommendMobx.setImgLoading(productNo)
          } else {
            menuMobx.setImgLoading(productNo)
          }
          setTimeout(() => {
            delete this.topImgMap[key]
          }, 0)
        }
      }
    }
  }
  scollToCategory (categoryNo: string) {
    if (restaurantConfig.displayMode !== 'waterfall') {
      scrollController.setForbidSearchBar(true)
      scst && clearTimeout(scst)
      const ele: HTMLElement = document.querySelector(`#category-item-${categoryNo}`)
      const topEle: HTMLElement = document.querySelector('.product-template')
      const offsetTop = ele?.offsetTop || 0
      return handleEleScrollTo?.({
        y: offsetTop + (topEle?.offsetTop || 0) - 56 - (restaurantConfig.displayMode === 'list' ? 56 : 0)
      }).then(() => {
        scst = setTimeout(() => scrollController.setForbidSearchBar(false), 800)
      }, () => {
        scrollController.setForbidSearchBar(false)
      })
    } else {
      return Promise.reject()
    }
  }

  /** 定位菜单中的餐品；分类模式需先切换到该餐品所属分类。 */
  scrollToProduct (productNo: string) {
    const product = productMobx.noToViewProductMap[productNo]
    if (!product) {
      return
    }
    const categoryNo = menuMobx.categories.find(category => category.products.some(item => item.no === productNo))?.no || ''
    if (menuMobx.searchKey !== null) {
      menuMobx.setSearchKey(null)
    }
    if (restaurantConfig.displayMode === 'category' && categoryNo) {
      menuMobx.selectCategory(categoryNo)
    }

    setTimeout(() => {
      const productElement = [
        categoryNo ? document.getElementById(`waterfallproduct${productNo}${categoryNo}`) : null,
        document.getElementById(`waterfallproduct${productNo}`),
        document.getElementById(`classicproduct${productNo}`),
        document.getElementById(`listproduct${productNo}`)
      ].find(Boolean) as HTMLElement | undefined
      const menuContent = document.querySelector('ion-content.menu-container') as any
      if (!productElement || !menuContent?.getScrollElement) {
        return
      }
      menuContent.getScrollElement().then((scrollElement: HTMLElement) => {
        const top = productElement.getBoundingClientRect().top - scrollElement.getBoundingClientRect().top + scrollElement.scrollTop - 8
        menuContent.scrollToPoint(0, Math.max(top, 0), 300)
      })
    }, 50)
  }
  /** 获取购物车推荐 */
  // 触发商品推荐
  setStartRecommendProduct (event, fn?: any) {
    if (decorationMobx.mealDecorates.openRecommend === 1) {
      // 滚动事件触发保存滚动距离
      event && event.detail.scrollTop && (scrollTop = event.detail.scrollTop)
      this.setRecommendDebounce(fn)
    }
  }
  // 发送强弱推送防抖3s执行
  private setRecommendDebounce = debounce((fn?: any) => {
    this.getProductRecommend(fn)
  }, runWait)
  // 获取到当前屏幕内推荐的商品
  private async getProductRecommend (fn?: any) {
    if (canRecommendProduct) {
      const res = await ProductAPI.getRecommendCart()
      if (!res) {
        return this.clearRecommendProductTimer()
      }
      canRecommendProduct = false
      let { recommend_products = [] } = res
      // 筛选出可以单独购买，上架，有库存的商品
      let recommendProducts = recommend_products.filter(item => {
        const viewProduct = productMobx.noToViewProductMap[item]
        if (viewProduct && viewProduct.isNotSingleInCombo && viewProduct.isShowInMenu && !viewProduct.disable && viewProduct.saleCnt !== 0) {
          return true
        }
        return false
      })
      let { isSuccess, product = null } = decorationMobx.mealDecorates.recommendType === 'shake' ? this.recommendProductShake(recommendProducts) : this.recommendProductBubble(recommendProducts)
      this.clearRecommendProductTimer(isSuccess, product, fn)
    }
  }
  // 弱推送
  private recommendProductShake (recommendProducts) {
    for (let i = 0; i < recommendProducts.length; i++) {
      let recommendProductNo = recommendProducts[i]
      if (restaurantConfig.displayMode === 'waterfall') {
        const { offsetTop: wrapOffsetTop, styleMap } = this.waterfallData
        let zone = [scrollTop - wrapOffsetTop, clientHeight - tabHeight + scrollTop - wrapOffsetTop]
        let { top, height } = styleMap[recommendProductNo]
        // 前后区间按照商品高度 1/3 放大区间范围
        if (top + height / 3 >= zone[0] && top + height * 2 / 3 <= zone[1]) {
          return {
            isSuccess: true,
            product: { no: recommendProductNo }
          }
        }
      } else {
        let { categories } = menuMobx
        for (let j = 0; j < categories.length; j++) {
          let { products } = categories[j]
          let findIndex = products.findIndex((product) => recommendProductNo === product.no)
          if (findIndex >= 0) {
            let thisProdDom = document.querySelectorAll('.category-item')[j]?.querySelectorAll('.product-item')?.[findIndex] as HTMLElement
            if (thisProdDom) {
              let wrapOffsetTop = (document.querySelector('.product-template') as HTMLElement)?.offsetTop || 0
              let zone = [scrollTop - wrapOffsetTop, clientHeight - tabHeight + scrollTop - wrapOffsetTop]
              let height = thisProdDom.offsetHeight || 0
              let top = thisProdDom.offsetTop || 0
              if (top >= zone[0] && (top + height) <= zone[1]) {
                return {
                  isSuccess: true,
                  product: { no: recommendProductNo }
                }
              }
            }
          }
        }
      }
    }
    return {
      isSuccess: false,
    }
  }
  // 强推送
  private recommendProductBubble (recommendProducts) {
    const products = menuMobx.products
    for (let i = 0; i < recommendProducts.length; i++) {
      let recommendProductNo = recommendProducts[i]
      let product = products.find((product) => recommendProductNo === product.no)
      return {
        isSuccess: true,
        product
      }
    }
    return {
      isSuccess: false,
    }
  }
  // 触发回调，并清除定时器
  clearRecommendProductTimer (isSuccess: boolean = false, product?, fn?: any) {
    if (isSuccess) {
      fn && fn(product, decorationMobx.mealDecorates.recommendType)
      RecommendProductTimer = setTimeout(() => {
        canRecommendProduct = true
      }, recommendWait)
    } else {
      // 当前窗口未找到商品，重新计时
      canRecommendProduct = true
      clearTimeout(RecommendProductTimer)
    }
  }
}

export default new WaterfallCalc()
